export * from './metadaServiceOrderClaim';
export * from './metadaServiceVehicle';
export * from './metadaWorkshop';
export * from './metadaWorkshopBasket';
export * from './metadaWorkshopBasketAction';
export * from './metadaWorkshopCheckin';
export * from './metadaWorkshopCodelist';
export * from './metadaWorkshopGoodwill';
export * from './metadaWorkshopHandover';
export * from './metadaWorkshopInsuranceTypes';
export * from './metadaWorkshopIntegration';
export * from './metadaWorkshopLabourCatalog';
export * from './metadaWorkshopLabourRate';
export * from './metadaWorkshopLabourUnit';
export * from './metadaWorkshopMaterialBasket';
export * from './metadaWorkshopMaterialDiscountGroup';
export * from './metadaWorkshopMeasurementUnitLabourOperation';
export * from './metadaWorkshopOrderServicePackage';
export * from './metadaWorkshopPostponeJob';
export * from './metadaWorkshopServiceCampaign';
export * from './metadaWorkshopServiceCase';
export * from './metadaWorkshopServiceCaseActions';
export * from './metadaWorkshopServiceCaseType';
export * from './metadaWorkshopServiceOrder';
export * from './metadaWorkshopServiceOrderActions';
export * from './metadaWorkshopServiceOrderClaim';
export * from './metadaWorkshopServiceOrderCustomerContract';
export * from './metadaWorkshopServiceOrderDiscount';
export * from './metadaWorkshopServiceOrderDocuments';
export * from './metadaWorkshopServiceOrderGroup';
export * from './metadaWorkshopServiceOrderJob';
export * from './metadaWorkshopServiceOrderJobItem';
export * from './metadaWorkshopServiceOrderVariant';
export * from './metadaWorkshopServiceOrderVehicleClass';
export * from './metadaWorkshopServicePackage';
export * from './metadaWorkshopServicePackagesCategory';
export * from './metadaWorkshopSmallUnitMaterial';
export * from './metadaWorkshopVehicleClass';
export * from './metadaWorkshopWorkBasket';
export * from './metadaWorkshopWorkSplitting';
export * from './metadaWorkshopWorkType';
export * from './serviceInspectionNotification';
export * from './workshop';
export * from './workshopInterest';
export * from './workshopInterestCustomerInquiry';
export * from './workshopInterestSeriesDefinition/api';
export * from './workshopInterestSeriesDefinition/types';
